import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { COUNT_RULE_RETRO_QUESTION, COUNT_RULE_RETRO_WARNING } from "../lib/count-rule";

/**
 * TASK-190 (PRD S8) — the three-way warn dialog shown when an ADMIN changes
 * the rule/days of an EXISTING webhook source (never on create — the create
 * form never renders this). Built next to ConfirmDialog.tsx instead of
 * extending it: ConfirmDialog is a two-way confirm/cancel used elsewhere,
 * and a third, differently-weighted primary action doesn't fit that shape
 * without changing every existing caller's behavior.
 */

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** "Nein, nur neue Events" — save the rule, no retroactive run. */
  onSaveOnly: () => void;
  /** "Ja, rückwirkend angleichen" — save the rule AND book a run. */
  onSaveRetroactive: () => void;
}

export function CountRuleRetroDialog({ open, onOpenChange, onSaveOnly, onSaveRetroactive }: Props) {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-overlay bg-overlay animate-fade-in" />
        <AlertDialog.Content className="fixed left-1/2 top-1/2 z-modal w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-md border border-border-primary bg-bg-elevated shadow-overlay animate-fade-in">
          <div className="border-b border-border-primary px-5 py-3">
            <AlertDialog.Title className="font-medium text-text-primary">
              Zählregel geändert
            </AlertDialog.Title>
          </div>
          <AlertDialog.Description asChild>
            <div className="flex flex-col gap-2 px-5 py-4 text-sm">
              <p className="text-text-primary">{COUNT_RULE_RETRO_QUESTION}</p>
              <p className="font-medium text-danger">{COUNT_RULE_RETRO_WARNING}</p>
            </div>
          </AlertDialog.Description>
          <div className="flex flex-col gap-2 border-t border-border-primary bg-bg-secondary px-5 py-3">
            <AlertDialog.Action asChild>
              <button
                type="button"
                onClick={onSaveOnly}
                className="rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-text-on-accent hover:bg-accent-hover"
              >
                Nein, nur neue Events
              </button>
            </AlertDialog.Action>
            <p className="text-center text-[11px] text-text-secondary">
              wenn du dir nicht sicher bist
            </p>
            <button
              type="button"
              onClick={onSaveRetroactive}
              className="rounded-md bg-danger px-3 py-1.5 text-sm font-medium text-text-inverse hover:opacity-90"
            >
              Ja, rückwirkend angleichen
            </button>
            <AlertDialog.Cancel asChild>
              <button
                type="button"
                className="rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 text-sm font-medium text-text-primary hover:bg-bg-hover"
              >
                Abbrechen
              </button>
            </AlertDialog.Cancel>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
